import React from 'react'
import { View } from 'react-native'

import { SPACE } from '@ui-kit/constants'

import type { Props } from './types'

/**
 * @deprecated This component is deprecated and will be removed when usage is 0%.
 * Please use View from react-native with Tailwind styles.
 */
const Spacer = (props: Props): JSX.Element => (
  <View style={props.horizontal ? { width: SPACE[props.size] } : { height: SPACE[props.size] }} />
)

export default Spacer
